<template>
    <div class="btn-group" role="group">
        <slot></slot>
    </div>
</template>
<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
    name: "ButtonGroup",
});
</script>